if (window.swag.env.CDN_PATH) {
  __webpack_public_path__ = window.swag.env.CDN_PATH;
}